// extracted by mini-css-extract-plugin
export default {"inputCode":"CodeInput_inputCode__P4Uvp"};